const KEY = 'glass_cutter_history';
const MAX_RUNS = 100;

function load() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; }
  catch { return []; }
}

function save(runs) {
  try { localStorage.setItem(KEY, JSON.stringify(runs)); } catch {}
}

export function getHistory() {
  return load();
}

export function saveRun({ stock, order, settings, result }) {
  const runs = load();
  const id = Date.now();
  runs.unshift({ id, createdAt: new Date().toISOString(), stock, order, settings, result });
  save(runs.slice(0, MAX_RUNS));
  return id;
}

export function deleteRun(id) {
  save(load().filter((r) => r.id !== id));
}
